/* Memovelle theme JS — קרוסלת גלריה + כפתורי כמות */
(function () {
  'use strict';

  /* ---- קרוסלת גלריה (עמוד הבית + עמוד מוצר) ---- */
  var main = document.getElementById('mainImg');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumb'));
  if (main && thumbs.length) {
    var count = document.getElementById('gCount');
    var idx = 0;

    var show = function (i) {
      idx = (i + thumbs.length) % thumbs.length;
      var btn = thumbs[idx];
      main.src = btn.getAttribute('data-full') || btn.querySelector('img').src;
      main.alt = btn.getAttribute('aria-label') || '';
      thumbs.forEach(function (b) { b.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
      if (count) { count.textContent = (idx + 1) + ' / ' + thumbs.length; }
    };

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { show(i); });
    });

    var nextBtn = document.getElementById('gNext');
    var prevBtn = document.getElementById('gPrev');
    if (nextBtn) { nextBtn.addEventListener('click', function () { show(idx + 1); }); }
    if (prevBtn) { prevBtn.addEventListener('click', function () { show(idx - 1); }); }

    var frame = document.querySelector('.gallery-frame');
    if (frame) {
      frame.setAttribute('tabindex', '0');
      frame.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { show(idx + 1); e.preventDefault(); }
        if (e.key === 'ArrowRight') { show(idx - 1); e.preventDefault(); }
      });
      var startX = null;
      frame.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      frame.addEventListener('touchend', function (e) {
        if (startX === null) { return; }
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) { show(dx > 0 ? idx + 1 : idx - 1); }
        startX = null;
      }, { passive: true });
    }
  }

  /* ---- כפתורי +/− לכל שדה כמות ---- */
  document.querySelectorAll('.qty').forEach(function (box) {
    var input = box.querySelector('input');
    if (!input) { return; }
    var minAllowed = parseInt(input.getAttribute('min') || '1', 10);
    box.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || minAllowed;
        v += parseInt(btn.getAttribute('data-step'), 10);
        if (v < minAllowed) { v = minAllowed; }
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
})();
